<template>
  <div>
    <div class="main-title">账户间转账</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add" icon="el-icon-plus">账户间转账</el-button>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="searchForm.daterange"
              type="daterange"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="datePickerOptions"
              @change="search(searchParams)">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        style="width:100%">
        <el-table-column
          prop="fin_time"
          label="转账时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="from_account_name"
          label="转出账户"
          width="150">
        </el-table-column>
        <el-table-column
          prop="to_account_name"
          label="转入账户"
          width="150">
        </el-table-column>
        <el-table-column
          prop="fin_money"
          label="转账金额"
          width="120">
        </el-table-column>
        <el-table-column
          prop="fin_no"
          label="凭证号"
          width="150">
        </el-table-column>
        <el-table-column
          prop="fin_status"
          label="状态"
          width="80">
          <template slot-scope="scope">
            <span :class="{'text-danger': scope.row.fin_status === '已作废'}">{{ scope.row.fin_status }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作人"
          width="100">
        </el-table-column>
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <el-button 
              v-if="scope.row.fin_status === '正常'"
              type="text" 
              size="small" 
              class="text-danger"
              @click="handleCancel(scope.row)">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- 新增转账表单 -->
    <el-dialog title="账户间转账" :visible.sync="addFormVisible" width="500px">
      <el-form :model="addForm" ref="addForm" :rules="addFormRules" label-width="100px">
        <el-form-item label="转出账户" prop="from_account_id">
          <el-select v-model="addForm.from_account_id" placeholder="请选择转出账户" style="width: 100%">
            <el-option
              v-for="item in accountList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转入账户" prop="to_account_id">
          <el-select v-model="addForm.to_account_id" placeholder="请选择转入账户" style="width: 100%">
            <el-option
              v-for="item in accountList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转账金额" prop="fin_money">
          <el-input v-model="addForm.fin_money" type="number" placeholder="请输入金额"></el-input>
        </el-form-item>
        <el-form-item label="转账时间" prop="fin_time">
          <el-date-picker
            v-model="addForm.fin_time"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="凭证号" prop="fin_no">
          <el-input v-model="addForm.fin_no" placeholder="请输入凭证号"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFormCommit" :loading="addFormCommiting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
import moment from 'moment'

export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    const validateMoney = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('金额必须大于0'));
      } else {
        callback();
      }
    };
    const validateAccount = (rule, value, callback) => {
      if (this.addForm.from_account_id && this.addForm.to_account_id && this.addForm.from_account_id === this.addForm.to_account_id) {
        callback(new Error('转出账户和转入账户不能相同'));
      } else {
        callback();
      }
    };

    return {
      sqlcode: 'finance_transfer',
      pageSize: 50,
      searchForm: {
        daterange: [
          new Date(),
          new Date()
        ]
      },
      accountList: [],
      addFormVisible: false,
      addFormCommiting: false,
      addForm: {
        from_account_id: '',
        to_account_id: '',
        fin_money: '',
        fin_time: '',
        fin_no: '',
        remark: ''
      },
      addFormRules: {
        from_account_id: [
          { required: true, message: '请选择转出账户', trigger: 'change' },
          { validator: validateAccount, trigger: 'change' }
        ],
        to_account_id: [
          { required: true, message: '请选择转入账户', trigger: 'change' },
          { validator: validateAccount, trigger: 'change' }
        ],
        fin_money: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { validator: validateMoney, trigger: 'blur' }
        ],
        fin_time: [
          { required: true, message: '请选择转账时间', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    searchParams () {
      if (!this.searchForm.daterange || this.searchForm.daterange.length === 0) {
        return {}
      } else {
        return {
          daterange_start: moment(this.searchForm.daterange[0]).format('YYYY-MM-DD'),
          daterange_end: moment(this.searchForm.daterange[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      }
    }
  },
  created() {
    this.getAccountList();
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.fin_status === '已作废') {
        return 'row-gray' // You might need to define this class in your global styles or scoped style if not present, or reuse 'row-red' or similar.
      }
      return ''
    },
    getAccountList() {
      this.$http.get('/dbapi/fin_account_list', {
        params: { state: '1' }
      }).then(res => {
        if (res.data.success) {
          this.accountList = res.data.list;
        }
      });
    },
    add() {
      this.addForm = {
        from_account_id: '',
        to_account_id: '',
        fin_money: '',
        fin_time: moment().format('YYYY-MM-DD HH:mm:ss'),
        fin_no: '',
        remark: ''
      };
      this.addFormVisible = true;
      if (this.$refs.addForm) {
        this.$refs.addForm.clearValidate();
      }
    },
    addFormCommit() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addFormCommiting = true;
          this.$http.post('/dbapi/finance_transfer', this.addForm).then(res => {
            this.addFormCommiting = false;
            if (res.data.success) {
              this.$message.success('转账成功');
              this.addFormVisible = false;
              this.refresh();
            } else {
              this.$message.error(res.data.message);
            }
          }).catch(err => {
            this.addFormCommiting = false;
            this.$message.error('系统错误');
          });
        }
      });
    },
    handleCancel(row) {
      this.$confirm('确定要作废这条转账记录吗？', '提示', {
        confirmButtonText: '确定作废',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/finance_transfer', {
          action: 'cancel',
          id: row.id
        }).then(res => {
          if (res.data.success) {
            this.$message.success('作废成功');
            this.refresh();
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          this.$message.error('系统错误');
        });
      });
    }
  }
}
</script>

<style scoped>
.text-danger {
  color: #F56C6C;
}
.row-gray {
  color: #909399;
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// src/components/finance/Transfer.vue